import React, { Component } from "react";
import { AlertTriangle, AlertOctagon, Info } from "lucide-react";

import { Modal, Button } from "../../design-system";

/**
 * Wrapper du DS Modal exposant window.showConfirmation pour conserver
 * l'API utilisée partout via utils/confirmAlert.js.
 *
 * Types : 'warning' | 'danger' | 'info'.
 */
const TYPE_CONFIG = {
  warning: {
    Icon: AlertTriangle,
    iconCls: "bg-warn-bg text-warn",
    confirmVariant: "primary",
  },
  danger: {
    Icon: AlertOctagon,
    iconCls: "bg-danger-bg text-danger",
    confirmVariant: "danger",
  },
  info: {
    Icon: Info,
    iconCls: "bg-info-bg text-info",
    confirmVariant: "primary",
  },
};

class ConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      title: "",
      message: "",
      onConfirm: null,
      onCancel: null,
      confirmText: "Confirmer",
      cancelText: "Annuler",
      type: "warning",
    };
  }

  componentDidMount() {
    window.showConfirmation = (options) => {
      this.setState({
        isOpen: true,
        title: options.title || "Confirmation",
        message: options.message || "Êtes-vous sûr ?",
        onConfirm: options.onConfirm || (() => {}),
        onCancel: options.onCancel || (() => {}),
        confirmText: options.confirmText || "Confirmer",
        cancelText: options.cancelText || "Annuler",
        type: options.type || "warning",
      });
    };
  }

  componentWillUnmount() {
    delete window.showConfirmation;
  }

  handleConfirm = () => {
    const { onConfirm } = this.state;
    this.closeModal();
    if (onConfirm) onConfirm();
  };

  handleCancel = () => {
    const { onCancel } = this.state;
    this.closeModal();
    if (onCancel) onCancel();
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { isOpen, title, message, confirmText, cancelText, type } = this.state;
    const cfg = TYPE_CONFIG[type] || TYPE_CONFIG.warning;
    const { Icon, iconCls, confirmVariant } = cfg;

    return (
      <Modal
        isOpen={isOpen}
        onClose={this.handleCancel}
        size="sm"
        hideCloseButton
        footer={
          <>
            <Button variant="ghost" onClick={this.handleCancel}>
              {cancelText}
            </Button>
            <Button variant={confirmVariant} onClick={this.handleConfirm}>
              {confirmText}
            </Button>
          </>
        }
      >
        <div className="flex items-start gap-3">
          <div className={`shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${iconCls}`}>
            <Icon className="w-5 h-5" strokeWidth={1.8} />
          </div>
          <div className="leading-tight pt-0.5">
            <div className="text-base font-bold tracking-tight">{title}</div>
            {message && (
              <p className="text-sm text-mute mt-1.5 leading-relaxed">{message}</p>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

export default ConfirmationModal;
